import React from "react"

interface InputFieldProps {
  className?: string
  htmlName: string
  id: string
  initialValue?: string
  isRequired?: boolean
  label: string
  onChange(e: React.ChangeEvent<HTMLInputElement>): void
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>
  style?: string
  type?: string
  maxLength?: number
}

const InputField: React.FC<InputFieldProps> = ({
  className,
  htmlName,
  id,
  initialValue,
  isRequired,
  label,
  onChange,
  onKeyDown,
  style = "full",
  type,
  maxLength
}) => {
  const labelTag = () => {
    if (label) {
      return <label htmlFor={id}>{label}</label>
    }
  }

  const classNames = ["field-grouped", `field-grouped--${style}`, className]

  return (
    <div className="field">
      <div className={classNames.join(" ")} key={id}>
        {labelTag()}
        <input
          defaultValue={initialValue || ""}
          id={id}
          key={id}
          name={htmlName}
          onChange={onChange}
          onKeyDown={onKeyDown}
          required={isRequired || false}
          type={type || "text"}
          maxLength={maxLength}
        />
      </div>
    </div>
  )
}

export default InputField
